// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"117":"capture-app","378":"admin-app"}[chunkId] + "." + {"117":"c9967e40","378":"a2d343b8"}[chunkId] + ".chunk.css";
};